"use strict";

module.exports = require('events').EventEmitter;